var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"GalleryFileDelete"},[_c('div',{attrs:{"dpadding":"","tcenter":"","strong":""}},[_vm._v(_vm._s(_vm.$locale["delete_confirm"]))]),_c('div',{attrs:{"dpadding":""}},[_c('Confirm',{attrs:{"confirm":_vm.deleteConfirm}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }